import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=6bbc50f2&scoped=true"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"
import style0 from "./Web.vue?vue&type=style&index=0&id=6bbc50f2&prod&scoped=true&lang=css"
import style1 from "./Web.vue?vue&type=style&index=1&id=6bbc50f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc50f2",
  null
  
)

export default component.exports